export default function Hero() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-[72px] pb-16 md:pb-0 overflow-hidden"
    >
      <div className="absolute inset-0 bg-background-100"></div>

      <div className="relative w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-12 xl:gap-16">
          <div className="flex-1 w-full text-center lg:text-left pt-8 md:pt-0">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-6">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse"></span>
              实时更新 · 全网热点追踪
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-tight mb-4">
              91吃瓜
              <span className="block text-primary-500 mt-1">吃瓜群众聚集地</span>
            </h1>

            <p className="text-lg sm:text-xl text-foreground-600 font-heading mb-6">
              热点一网打尽，吃瓜绝不掉队
            </p>

            <p className="text-sm sm:text-base text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              91吃瓜是全网最活跃的吃瓜群众聚集社区，每日追踪娱乐圈八卦、社会热点与网络热议事件。
              我们聚合海量真实爆料与深度讨论，让你第一时间掌握最新动态。
              无论是明星大瓜、网红翻车还是行业黑幕，这里都有最鲜活的互动交流与最热闹的吃瓜氛围。
              目前社区已覆盖娱乐八卦、社会民生、科技财经、体育电竞等多个热门领域。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">200万+</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">活跃吃瓜群众</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-500 font-heading">50万+</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">每日话题讨论</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-secondary-500 font-heading">7×24h</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">全天候热点追踪</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#carousel"
                onClick={(e) => { e.preventDefault(); handleNavClick('#carousel'); }}
                className="inline-flex items-center gap-2 px-7 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer text-sm"
              >
                立即吃瓜
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-sm"></i>
                </span>
              </a>
              <a
                href="#topics"
                onClick={(e) => { e.preventDefault(); handleNavClick('#topics'); }}
                className="inline-flex items-center gap-2 px-7 py-3 bg-background-50 text-foreground-700 font-medium rounded-full border border-background-300 hover:border-primary-300 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer text-sm"
              >
                探索话题
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-compass-3-line text-sm"></i>
                </span>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex items-center justify-center">
            <div className="relative w-full max-w-[500px] aspect-[4/5] lg:aspect-[5/4] overflow-hidden rounded-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=A%20vibrant%20artistic%20illustration%20of%20a%20digital%20community%20hub%20with%20warm%20coral%20and%20amber%20gradients%2C%20showing%20people%20avatars%20gathered%20around%20floating%20news%20bubbles%20and%20topic%20cards%2C%20modern%20flat%20design%20with%20soft%20geometric%20shapes%2C%20entertainment%20and%20social%20media%20theme%2C%20clean%20composition%20with%20gentle%20warm%20lighting%2C%20editorial%20quality%20illustration%20style%2C%20abstract%20background%20with%20rounded%20elements%20in%20warm%20peach%20and%20cream%20tones&width=1000&height=1250&seq=hero-main-2026&orientation=portrait"
                alt="91吃瓜群众社区 - 热点讨论与互动交流"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 hidden md:block">
        <a
          href="#carousel"
          onClick={(e) => { e.preventDefault(); handleNavClick('#carousel'); }}
          className="flex flex-col items-center gap-2 text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
        >
          <span className="text-xs">往下看</span>
          <span className="w-5 h-5 flex items-center justify-center animate-bounce">
            <i className="ri-arrow-down-s-line"></i>
          </span>
        </a>
      </div>
    </section>
  );
}